export const attribution = () => "cartofixer.be";
export const credits = () => "";
